// src/components/property-activities-cross-sell/property-activities-cross-sell.tsx
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpreadProps(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  fragment LodgingEGDSGraphicTextFragment on EGDSGraphicText {\n    text\n    graphic {\n      ... on Icon {\n        id\n        size\n      }\n    }\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n  fragment EGDSPlainTextFragment on EGDSPlainText {\n    text\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _taggedTemplateLiteral([
        "\n  fragment EGDSStylizedTextFragment on EGDSStylizedText {\n    __typename\n    text\n    theme\n    weight\n    size\n    decorative\n    accessibility\n  }\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = _taggedTemplateLiteral([
        "\n  fragment EGDSSpannableTextContentFragment on EGDSText {\n    ...EGDSStylizedTextFragment\n    ...EGDSPlainTextFragment\n    ...LodgingEGDSGraphicTextFragment\n  }\n\n  ",
        "\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = _taggedTemplateLiteral([
        "\n  fragment EGDSSpannableTextFragment on EGDSSpannableText {\n    text\n    contents {\n      ...EGDSSpannableTextContentFragment\n    }\n    inlineContent {\n      ...EGDSSpannableTextContentFragment\n    }\n  }\n\n  ",
        "\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = _taggedTemplateLiteral([
        "\n  fragment PropertyActivitiesCrossSellActionFragment on PropertyActivitiesCrossSellLinkButton {\n    action {\n      actionType\n      activityId\n      analytics {\n        eventType\n        linkName\n        referrerId\n      }\n    }\n    button {\n      accessibility\n      iconPosition\n      text\n      icon {\n        id\n      }\n    }\n  }\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = _taggedTemplateLiteral([
        "\n  fragment PropertyActivitiesCrossSellDescriptionFragment on EGDSPlainText {\n    text\n  }\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = _taggedTemplateLiteral([
        "\n  fragment PropertyActivitiesCrossSellHeadingFragment on LodgingHeader {\n    accessibilityLabel\n    icon {\n      id\n      token\n    }\n    text\n  }\n"
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = _taggedTemplateLiteral([
        "\n  fragment PropertyActivitiesCrossSellPriceFragment on DisplayPrice {\n    price {\n      accessibilityLabel\n      formatted\n    }\n  }\n"
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = _taggedTemplateLiteral([
        "\n  query PropertyActivitiesCrossSellQuery(\n    $context: ContextInput!\n    $propertyId: String!\n    $searchCriteria: PropertySearchCriteriaInput!\n    $activityNaturalKey: ActivityNaturalKeyInput\n  ) {\n    propertyActivitiesCrossSell(\n      context: $context\n      propertyId: $propertyId\n      searchCriteria: $searchCriteria\n      activityNaturalKey: $activityNaturalKey\n    ) {\n      actions {\n        ...PropertyActivitiesCrossSellActionFragment\n      }\n      activityId\n      description {\n        ...PropertyActivitiesCrossSellDescriptionFragment\n      }\n      heading {\n        ...PropertyActivitiesCrossSellHeadingFragment\n      }\n      liveAnnounceMessage\n      offerActivityDescription {\n        ...EGDSSpannableTextFragment\n      }\n      price {\n        ...PropertyActivitiesCrossSellPriceFragment\n      }\n      showTracking {\n        referrerId\n        linkName\n        eventType\n      }\n      sideSheet {\n        dismissButtonAccessibilityText\n        heading\n        subtitle\n      }\n    }\n  }\n\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
import React11 from "react";
import { gql as gql10, useQuery } from "@apollo/client";
import { useBexApi } from "@shared-ui/bex-api-context";
import { useClickTracker } from "@shared-ui/clickstream-analytics-context";
// ../internal/src/components/lodging-egds-text/egds-spannable-text.tsx
import React5 from "react";
import { gql as gql5 } from "@apollo/client";
import { UitkText as UitkText4 } from "uitk-react-text";
// ../internal/src/components/lodging-egds-text/egds-spannable-text-content.tsx
import React4 from "react";
import { gql as gql4 } from "@apollo/client";
// ../internal/src/components/lodging-egds-graphic-text/lodging-egds-graphic-text.tsx
import React from "react";
import { gql } from "@apollo/client";
import { UitkIcon, UitkIconSize } from "uitk-react-icons";
import { UitkSpacing } from "uitk-react-spacing";
import { UitkText } from "uitk-react-text";
var fragment = gql(_templateObject());
var LodgingEGDSGraphicText = function(param) {
    var data = param.data, textProps = param.textProps, customTextSize = param.customTextSize;
    var text = data.text, graphic = data.graphic;
    return /* @__PURE__ */ React.createElement("div", null, (graphic === null || graphic === void 0 ? void 0 : graphic.__typename) === "Icon" && graphic.id && /* @__PURE__ */ React.createElement(UitkSpacing, {
        padding: {
            inlineend: "two"
        }
    }, /* @__PURE__ */ React.createElement(UitkIcon, {
        name: graphic.id,
        size: graphic.size ? UitkIconSize[graphic.size] : UitkIconSize.EXTRA_SMALL
    })), /* @__PURE__ */ React.createElement(UitkText, _objectSpreadProps(_objectSpread({
        size: customTextSize || 200
    }, textProps), {
        inline: !!graphic
    }), text));
};
LodgingEGDSGraphicText.fragment = fragment;
LodgingEGDSGraphicText.displayName = "LodgingEGDSGraphicText";
// ../internal/src/components/lodging-egds-text/lodging-egds-plain-text.tsx
import React2 from "react";
import { gql as gql2 } from "@apollo/client";
import { UitkText as UitkText2 } from "uitk-react-text";
var fragment2 = gql2(_templateObject1());
var EGDSPlainText = function(param) {
    var className = param.className, inline = param.inline, size = param.size, align = param.align, data = param.data;
    var text = data.text;
    return /* @__PURE__ */ React2.createElement(UitkText2, {
        className: className,
        inline: inline,
        size: size,
        align: align
    }, text);
};
EGDSPlainText.fragment = fragment2;
EGDSPlainText.displayName = "EGDSPlainText";
// ../internal/src/components/lodging-egds-text/lodging-egds-stylized-text.tsx
import React3 from "react";
import { gql as gql3 } from "@apollo/client";
import { UitkText as UitkText3 } from "uitk-react-text";
var _obj;
// ../internal/src/components/lodging-egds-text/__private/text-theme.ts
var textThemeMapper = (_obj = {}, _defineProperty(_obj, "EMPHASIS" /* EMPHASIS */ , "emphasis"), _defineProperty(_obj, "LOYALTY" /* LOYALTY */ , "loyalty"), _defineProperty(_obj, "NEGATIVE" /* NEGATIVE */ , "negative"), _defineProperty(_obj, "POSITIVE" /* POSITIVE */ , "positive"), _defineProperty(_obj, "PRIMARY" /* PRIMARY */ , "emphasis"), _defineProperty(_obj, "SECONDARY" /* SECONDARY */ , "default"), _defineProperty(_obj, "INVERSE" /* INVERSE */ , "inverse"), _obj);
var _obj1;
// ../internal/src/components/lodging-egds-text/__private/text-weight.ts
var textWeightMapper = (_obj1 = {}, _defineProperty(_obj1, "BOLD" /* BOLD */ , "bold"), _defineProperty(_obj1, "MEDIUM" /* MEDIUM */ , "medium"), _defineProperty(_obj1, "REGULAR" /* REGULAR */ , "regular"), _obj1);
// ../internal/src/components/lodging-egds-text/lodging-egds-stylized-text.tsx
var fragment3 = gql3(_templateObject2());
var sizeMap = {
    "100": 100,
    "200": 200,
    "300": 300,
    "400": 400,
    "500": 500,
    "600": 600,
    "700": 700,
    "800": 800,
    "900": 900
};
var decorativeMap = {
    LINE_THROUGH: "s",
    SUBSCRIPT: "sub",
    SUPERSCRIPT: "sup",
    UNDERLINE: "u"
};
var EGDSStylizedText = function(_param) {
    var data = _param.data, props = _objectWithoutProperties(_param, [
        "data"
    ]);
    var theme = data.theme, weight = data.weight, size = data.size, decorative = data.decorative, accessibility = data.accessibility;
    var overflow = props.overflow, spacing = props.spacing, align = props.align, inline = props.inline;
    var textPropsSize = size || props.size;
    var textProps = {
        theme: theme ? textThemeMapper[theme] : void 0,
        weight: weight ? textWeightMapper[weight] : void 0,
        size: textPropsSize ? sizeMap[textPropsSize] : void 0,
        overflow: overflow,
        spacing: spacing,
        align: align,
        inline: inline
    };
    var Decorative = decorative && decorativeMap[decorative];
    var Accessibility = accessibility && /* @__PURE__ */ React3.createElement("span", {
        className: "is-visually-hidden"
    }, accessibility);
    var content = Decorative ? /* @__PURE__ */ React3.createElement(React3.Fragment, null, /* @__PURE__ */ React3.createElement(Decorative, null, data.text), Accessibility) : /* @__PURE__ */ React3.createElement(React3.Fragment, null, data.text, Accessibility);
    return /* @__PURE__ */ React3.createElement(UitkText3, _objectSpread({}, textProps), content);
};
EGDSStylizedText.fragment = fragment3;
EGDSStylizedText.displayName = "EGDSStylizedText";
// ../internal/src/components/lodging-egds-text/egds-spannable-text-content.tsx
var fragment4 = gql4(_templateObject3(), EGDSStylizedText.fragment, EGDSPlainText.fragment, LodgingEGDSGraphicText.fragment);
var EGDSSpannableTextContent = function(param) {
    var className = param.className, size = param.size, data = param.data;
    switch(data.__typename){
        case "EGDSStylizedText":
            return /* @__PURE__ */ React4.createElement(EGDSStylizedText, {
                className: className,
                data: data,
                size: size,
                inline: true
            });
        case "EGDSPlainText":
            return /* @__PURE__ */ React4.createElement(EGDSPlainText, {
                className: className,
                data: data,
                size: size,
                inline: true
            });
        case "EGDSGraphicText":
            return /* @__PURE__ */ React4.createElement(LodgingEGDSGraphicText, {
                data: data
            });
        default:
            return null;
    }
};
EGDSSpannableTextContent.fragment = fragment4;
EGDSSpannableTextContent.displayName = "EGDSSpannableTextContent";
// ../internal/src/components/lodging-egds-text/egds-spannable-text.tsx
var fragment5 = gql5(_templateObject4(), EGDSSpannableTextContent.fragment);
var EGDSSpannableText = function(props) {
    var _data_contents, _data_inlineContent, _data_inlineContent1;
    var align = props.align, data = props.data, styleProps = _objectWithoutProperties(props, [
        "align",
        "data"
    ]);
    if ((data === null || data === void 0 ? void 0 : (_data_contents = data.contents) === null || _data_contents === void 0 ? void 0 : _data_contents.length) === 0 && !(data === null || data === void 0 ? void 0 : (_data_inlineContent = data.inlineContent) === null || _data_inlineContent === void 0 ? void 0 : _data_inlineContent.length)) {
        return /* @__PURE__ */ React5.createElement(UitkText4, _objectSpreadProps(_objectSpread({}, styleProps), {
            inline: true,
            align: align
        }), data.text);
    }
    if (data === null || data === void 0 ? void 0 : (_data_inlineContent1 = data.inlineContent) === null || _data_inlineContent1 === void 0 ? void 0 : _data_inlineContent1.length) {
        return /* @__PURE__ */ React5.createElement(React5.Fragment, null, data.inlineContent.map(function(item, index) {
            return /* @__PURE__ */ React5.createElement(React5.Fragment, null, /* @__PURE__ */ React5.createElement(EGDSSpannableTextContent, _objectSpreadProps(_objectSpread({
                data: item
            }, styleProps), {
                key: "spannable-item-".concat(index)
            })));
        }));
    }
    return /* @__PURE__ */ React5.createElement(React5.Fragment, null, data.contents.map(function(item, index) {
        return /* @__PURE__ */ React5.createElement(React5.Fragment, {
            key: "spannable-item-".concat(index)
        }, /* @__PURE__ */ React5.createElement(EGDSSpannableTextContent, _objectSpread({
            data: item
        }, styleProps)));
    }));
};
EGDSSpannableText.fragment = fragment5;
EGDSSpannableText.displayName = "EGDSSpannableText";
// src/components/property-activities-cross-sell/property-activities-cross-sell.tsx
import { useRefContext, useVisibility, VisibilityEventType } from "@shared-ui/ref-context";
import { ViewLarge, Viewport } from "@shared-ui/viewport-context";
import { UitkLayoutFlex as UitkLayoutFlex2, UitkLayoutFlexItem as UitkLayoutFlexItem2 } from "uitk-react-layout-flex";
import { UitkLayoutGrid } from "uitk-react-layout-grid";
import { UitkSheet, UitkSheetContent } from "uitk-react-sheet";
import { UitkSpacing as UitkSpacing4 } from "uitk-react-spacing";
// src/components/property-activities-cross-sell/__private/__fragments/property-activities-cross-sell-action.tsx
import React6 from "react";
import { gql as gql6 } from "@apollo/client";
import { UitkIcon as UitkIcon2 } from "uitk-react-icons";
import { UitkLayoutGridItem } from "uitk-react-layout-grid";
import { UitkLink } from "uitk-react-link";
var __Fragment = gql6(_templateObject5());
var PropertyActivitiesCrossSellAction = function(param) {
    var data = param.data, onActionClick = param.onActionClick;
    var action = data.action, button = data.button;
    return /* @__PURE__ */ React6.createElement(React6.Fragment, null, action.map(function(buttonAction, index) {
        var _button_icon;
        /* @__PURE__ */ return React6.createElement(UitkLayoutGridItem, {
            key: "property-activities-cross-sell-action-".concat(index)
        }, /* @__PURE__ */ React6.createElement(UitkLink, {
            onClick: function() {
                return onActionClick(buttonAction.actionType, buttonAction.analytics);
            }
        }, /* @__PURE__ */ React6.createElement("button", {
            type: "button",
            "aria-expanded": "false"
        }, button.text, (button === null || button === void 0 ? void 0 : button.icon) && /* @__PURE__ */ React6.createElement(UitkIcon2, {
            name: button === null || button === void 0 ? void 0 : (_button_icon = button.icon) === null || _button_icon === void 0 ? void 0 : _button_icon.id
        }))));
    }));
};
PropertyActivitiesCrossSellAction.displayName = "PropertyActivitiesCrossSellAction";
PropertyActivitiesCrossSellAction.fragment = __Fragment;
// src/components/property-activities-cross-sell/__private/__fragments/property-activities-cross-sell-description.tsx
import React7 from "react";
import { gql as gql7 } from "@apollo/client";
import { UitkSpacing as UitkSpacing2 } from "uitk-react-spacing";
import { UitkText as UitkText5 } from "uitk-react-text";
var __Fragment2 = gql7(_templateObject6());
var PropertyActivitiesCrossSellDescription = function(param) {
    var data = param.data;
    var text = data.text;
    return /* @__PURE__ */ React7.createElement(UitkSpacing2, {
        margin: {
            blockstart: "one"
        }
    }, /* @__PURE__ */ React7.createElement(UitkText5, null, text));
};
PropertyActivitiesCrossSellDescription.displayName = "PropertyActivitiesCrossSellDescription";
PropertyActivitiesCrossSellDescription.fragment = __Fragment2;
// src/components/property-activities-cross-sell/__private/__fragments/property-activities-cross-sell-heading.tsx
import React8 from "react";
import { gql as gql8 } from "@apollo/client";
import { UitkIcon as UitkIcon3 } from "uitk-react-icons";
import { UitkLayoutFlex, UitkLayoutFlexItem } from "uitk-react-layout-flex";
import { UitkSpacing as UitkSpacing3 } from "uitk-react-spacing";
import { UitkHeading } from "uitk-react-text";
var __Fragment3 = gql8(_templateObject7());
var PropertyActivitiesCrossSellHeading = function(param) {
    var data = param.data;
    var icon = data.icon, text = data.text;
    return /* @__PURE__ */ React8.createElement(React8.Fragment, null, /* @__PURE__ */ React8.createElement(UitkLayoutFlex, null, icon && /* @__PURE__ */ React8.createElement(UitkLayoutFlexItem, null, /* @__PURE__ */ React8.createElement(UitkSpacing3, {
        padding: {
            inlineend: "two"
        }
    }, /* @__PURE__ */ React8.createElement(UitkIcon3, {
        name: icon.id
    }))), /* @__PURE__ */ React8.createElement(UitkLayoutFlexItem, null, /* @__PURE__ */ React8.createElement(UitkHeading, {
        size: 6
    }, text))));
};
PropertyActivitiesCrossSellHeading.displayName = "PropertyActivitiesCrossSellHeading";
PropertyActivitiesCrossSellHeading.fragment = __Fragment3;
// src/components/property-activities-cross-sell/__private/__fragments/property-activities-cross-sell-price.tsx
import React9 from "react";
import { gql as gql9 } from "@apollo/client";
import { UitkText as UitkText6 } from "uitk-react-text";
var __Fragment4 = gql9(_templateObject8());
var PropertyActivitiesCrossSellPrice = function(param) {
    var data = param.data;
    var _data_price = data.price, accessibilityLabel = _data_price.accessibilityLabel, formatted = _data_price.formatted;
    return /* @__PURE__ */ React9.createElement(UitkText6, {
        weight: "bold",
        "aria-label": accessibilityLabel
    }, formatted);
};
PropertyActivitiesCrossSellPrice.displayName = "PropertyActivitiesCrossSellHeading";
PropertyActivitiesCrossSellPrice.fragment = __Fragment4;
// src/components/property-activities-cross-sell/property-activities-cross-sell-provider.tsx
import React10 from "react";
var PropertyActivitiesCrossSellContext = React10.createContext(null);
var PropertyActivitiesCrossSellContextProvider = function(param) {
    var children = param.children;
    var mountRef = React10.useRef(false);
    var _React10_useState = _slicedToArray(React10.useState(false), 2), triggerRefetch = _React10_useState[0], setTriggerRefetch = _React10_useState[1];
    var _React10_useState1 = _slicedToArray(React10.useState({
        offerToken: "",
        productToken: ""
    }), 2), activityNaturalKey = _React10_useState1[0], setActivityNaturalKey = _React10_useState1[1];
    React10.useEffect(function() {
        if (mountRef.current) {
            setTriggerRefetch(true);
        }
    }, [
        activityNaturalKey.offerToken
    ]);
    React10.useEffect(function() {
        mountRef.current = true;
    }, []);
    var value = {
        triggerRefetch: triggerRefetch,
        setTriggerRefetch: setTriggerRefetch,
        activityNaturalKey: activityNaturalKey,
        setActivityNaturalKey: setActivityNaturalKey
    };
    return /* @__PURE__ */ React10.createElement(PropertyActivitiesCrossSellContext.Provider, {
        value: value
    }, children);
};
var usePropertyActivitiesCrossSellContext = function() {
    var context = React10.useContext(PropertyActivitiesCrossSellContext);
    if (!context) {
        return null;
    }
    return context;
};
// src/components/property-activities-cross-sell/property-activities-cross-sell.tsx
var __Query = gql10(_templateObject9(), PropertyActivitiesCrossSellDescription.fragment, PropertyActivitiesCrossSellHeading.fragment, PropertyActivitiesCrossSellAction.fragment, PropertyActivitiesCrossSellPrice.fragment, EGDSSpannableText.fragment);
var HIDE_STICKY_TARGET_SECTION = "Offers";
var PropertyActivitiesCrossSell = function(param) {
    var inputs = param.inputs, skipSsr = param.skipSsr, sectionRef = param.sectionRef;
    var _usePropertyActivitiesCrossSellContext, _usePropertyActivitiesCrossSellContext1, _usePropertyActivitiesCrossSellContext2, _usePropertyActivitiesCrossSellContext3;
    var context = useBexApi().context;
    var getTargets = useRefContext().getTargets;
    var analyticsTracker = useClickTracker();
    var triggerRefetch = (_usePropertyActivitiesCrossSellContext = usePropertyActivitiesCrossSellContext()) === null || _usePropertyActivitiesCrossSellContext === void 0 ? void 0 : _usePropertyActivitiesCrossSellContext.triggerRefetch;
    var setTriggerRefetch = (_usePropertyActivitiesCrossSellContext1 = usePropertyActivitiesCrossSellContext()) === null || _usePropertyActivitiesCrossSellContext1 === void 0 ? void 0 : _usePropertyActivitiesCrossSellContext1.setTriggerRefetch;
    var activityNaturalKey = (_usePropertyActivitiesCrossSellContext2 = usePropertyActivitiesCrossSellContext()) === null || _usePropertyActivitiesCrossSellContext2 === void 0 ? void 0 : _usePropertyActivitiesCrossSellContext2.activityNaturalKey;
    var setActivityNaturalKey = (_usePropertyActivitiesCrossSellContext3 = usePropertyActivitiesCrossSellContext()) === null || _usePropertyActivitiesCrossSellContext3 === void 0 ? void 0 : _usePropertyActivitiesCrossSellContext3.setActivityNaturalKey;
    var _React11_useState = _slicedToArray(React11.useState(false), 2), isStickyVisible = _React11_useState[0], setIsStickyVisible = _React11_useState[1];
    var dismissRef = React11.useRef(true);
    var isStickyVisibleRef = React11.useRef(true);
    var targetSectionRef = sectionRef || HIDE_STICKY_TARGET_SECTION;
    var _getTargets = getTargets([
        targetSectionRef
    ]), targetRef = _getTargets[targetSectionRef];
    var threshold = (targetRef === null || targetRef === void 0 ? void 0 : targetRef.current) && typeof window !== "undefined" && targetRef.current.clientHeight > window.innerHeight ? window.innerHeight * 0.6 / targetRef.current.clientHeight : 0.3;
    var targetList = [
        {
            id: targetSectionRef,
            ref: targetRef
        }
    ];
    var onVisibilityChange = React11.useCallback(function(visibilityEvents) {
        var targetVisible = false;
        Object.keys(visibilityEvents).forEach(function(sectionName) {
            targetVisible = sectionName === targetSectionRef && visibilityEvents[sectionName] === VisibilityEventType.PARTIAL_TOP || visibilityEvents[sectionName] === VisibilityEventType.PARTIAL_BOTTOM || visibilityEvents[sectionName] === VisibilityEventType.ENTER_COMPLETE;
        });
        if (dismissRef.current) {
            setIsStickyVisible(targetVisible);
        }
    }, [
        targetSectionRef
    ]);
    useVisibility(targetList, onVisibilityChange, {
        thresholds: [
            threshold
        ]
    });
    var variables = _objectSpreadProps(_objectSpread({}, inputs), {
        context: context
    });
    var _useQuery = useQuery(__Query, {
        variables: variables,
        ssr: !skipSsr,
        fetchPolicy: "no-cache",
        nextFetchPolicy: "no-cache"
    }), data = _useQuery.data, error = _useQuery.error, loading = _useQuery.loading, refetch = _useQuery.refetch;
    React11.useEffect(function() {
        if (triggerRefetch && setTriggerRefetch) {
            refetch(_objectSpreadProps(_objectSpread({}, variables), {
                activityNaturalKey: (activityNaturalKey === null || activityNaturalKey === void 0 ? void 0 : activityNaturalKey.offerToken) ? _objectSpread({}, activityNaturalKey) : null
            })).then(function() {
                setTriggerRefetch(false);
            });
        }
    }, [
        triggerRefetch
    ]);
    if (loading || error || !data || !data.propertyActivitiesCrossSell) {
        return null;
    }
    var _data_propertyActivitiesCrossSell = data.propertyActivitiesCrossSell, actions = _data_propertyActivitiesCrossSell.actions, description = _data_propertyActivitiesCrossSell.description, heading = _data_propertyActivitiesCrossSell.heading, liveAnnounceMessage = _data_propertyActivitiesCrossSell.liveAnnounceMessage, offerActivityDescription = _data_propertyActivitiesCrossSell.offerActivityDescription, price = _data_propertyActivitiesCrossSell.price, showTracking = _data_propertyActivitiesCrossSell.showTracking;
    if (isStickyVisible && isStickyVisibleRef.current && showTracking) {
        var referrerId = showTracking.referrerId, linkName = showTracking.linkName;
        isStickyVisibleRef.current = false;
        analyticsTracker("".concat(referrerId), "".concat(linkName));
    }
    var onActionClick = function(action, analytics) {
        if (analytics) {
            var referrerId = analytics.referrerId, linkName = analytics.linkName;
            analyticsTracker("".concat(referrerId), "".concat(linkName));
        }
        switch(action){
            case "OPEN" /* OPEN */ :
                if (typeof setActivityNaturalKey === "function") {
                    setActivityNaturalKey({
                        offerToken: '{"id":0,"dxID":449578,"dxItemID":3403693,"supplyServiceVersion":"V1","date":"2023-06-06T09:00","dxticketCountsByCategoryList":[{"ticketCategoryCode":"Adult_118036","count":1,"promoId":"0"}],"isUnpricedKey":true,"allDayActivity":false,"dxMetaDataList":[{"key":"DXItemDuration","value":"{\\"standardDays\\":1,\\"standardHours\\":24,\\"standardMinutes\\":1440,\\"standardSeconds\\":86400,\\"millis\\":86400000}"},{"key":"tpid","value":"1"},{"key":"eapid","value":"0"},{"key":"startDate","value":"2023-06-06"},{"key":"endDate","value":"2023-06-06"},{"key":"isGroundTransfer","value":"false"},{"key":"audience","value":"mip|mod|guest"},{"key":"savings","value":"0.0"}],"productUsedWithType":"PackageV2"}',
                        productToken: ""
                    });
                }
                break;
            case "DISMISS" /* DISMISS */ :
                dismissRef.current = false;
                setIsStickyVisible(false);
                break;
            case "EDIT" /* EDIT */ :
                break;
            case "REMOVE" /* REMOVE */ :
                if (typeof setActivityNaturalKey === "function") {
                    setActivityNaturalKey({
                        offerToken: "",
                        productToken: ""
                    });
                }
                break;
        }
    };
    var ViewportWrapper = function(param) {
        var wrapElement = param.wrapElement, children = param.children;
        if (wrapElement) {
            return /* @__PURE__ */ React11.createElement(Viewport, null, /* @__PURE__ */ React11.createElement(ViewLarge, null, children));
        }
        return children;
    };
    return /* @__PURE__ */ React11.createElement(UitkSheet, {
        isVisible: isStickyVisible,
        type: "bottom",
        triggerRef: null,
        liveAnnounceString: liveAnnounceMessage
    }, /* @__PURE__ */ React11.createElement(UitkSheetContent, null, /* @__PURE__ */ React11.createElement(ViewportWrapper, {
        wrapElement: !!(activityNaturalKey === null || activityNaturalKey === void 0 ? void 0 : activityNaturalKey.offerToken)
    }, /* @__PURE__ */ React11.createElement(React11.Fragment, null, /* @__PURE__ */ React11.createElement(PropertyActivitiesCrossSellHeading, {
        data: heading
    }), /* @__PURE__ */ React11.createElement(PropertyActivitiesCrossSellDescription, {
        data: description
    }))), offerActivityDescription && price && /* @__PURE__ */ React11.createElement(UitkSpacing4, {
        margin: {
            blockstart: "one"
        }
    }, /* @__PURE__ */ React11.createElement(UitkLayoutFlex2, {
        alignItems: "center",
        justifyContent: "space-between"
    }, /* @__PURE__ */ React11.createElement(UitkLayoutFlexItem2, null, /* @__PURE__ */ React11.createElement(UitkLayoutFlex2, {
        alignItems: "center"
    }, /* @__PURE__ */ React11.createElement(UitkLayoutFlexItem2, null, /* @__PURE__ */ React11.createElement(EGDSSpannableText, {
        data: offerActivityDescription
    })))), /* @__PURE__ */ React11.createElement(UitkLayoutFlexItem2, null, /* @__PURE__ */ React11.createElement(PropertyActivitiesCrossSellPrice, {
        data: price
    })))), /* @__PURE__ */ React11.createElement(UitkSpacing4, {
        margin: {
            blockstart: "three"
        }
    }, /* @__PURE__ */ React11.createElement(UitkLayoutGrid, {
        columns: [
            "max-content",
            "auto"
        ],
        space: {
            column: "twelve"
        }
    }, actions.map(function(action, index) {
        return /* @__PURE__ */ React11.createElement(PropertyActivitiesCrossSellAction, {
            key: "property-activities-cross-sell-action-".concat(index),
            data: action,
            onActionClick: onActionClick
        });
    })))));
};
PropertyActivitiesCrossSell.displayName = "PropertyActivitiesCrossSell";
export { PropertyActivitiesCrossSell, PropertyActivitiesCrossSellContextProvider, usePropertyActivitiesCrossSellContext };
//# sourceMappingURL=index.js.map